export default "__VITE_ASSET__5c94468a__"